import React from "react";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import Container from "reactstrap/lib/Container";
import { isMainSiteCode } from "Utils/siteConfig";
import { pipe } from "Utils/functionalUtils";
import ReviewsSendHOC from "HOC/ReviewsSendHOC";
import { useGetMobileTagsQuery } from "hooks/mobileQueries";
import TagButtonComponent from "Containers/TagButtonComponent";
import { AddReviewContainerV2, ReviewListContainerV3 } from "Containers/Review";
import { StubOperatorTariffs } from "ComponentsUI/Stub";
import { EmptyStubWrapper } from "ComponentsUI/EmptyStub";
import { BlockReviews } from "ComponentsUI/Blocks";
import Tariffs from "./Tariffs";
import { PaddingBottom } from "ComponentsUI/Spacings";

const List = (props) => {
	const {
		ApplicationModel: { text, siteCode },
		match: { params },
	} = props;

	const providerInetTvMobile = { name: text.INTERNET_TV_MOBILE };
	const providerInetMobile = { name: text.INTERNET_MOBILE };

	const { mobileTags } = useGetMobileTagsQuery();

	//Проверка на вывод стаба
	if (!mobileTags) {
		return <StubOperatorTariffs />;
	}

	return (
		<>
			{isMainSiteCode(siteCode) && <div></div>}
			{mobileTags?.length ? (
				<>
					<PaddingBottom>
						<Container>
							<TagButtonComponent
								mobileTags={mobileTags}
								tagCode={params.tagCode}
								ratesMobile={true}
								operatorStyle={true}
								providerInetTvMobile={providerInetTvMobile}
								providerInetMobile={providerInetMobile}
							/>
						</Container>
						<Tariffs />
					</PaddingBottom>
					{!params.tagCode && (
						<Container>
							<BlockReviews
								reviewLocation="ratesmobile_region"
								queryType="regionFull"
								text={text}
								reviews={
									<ReviewListContainerV3
										text={text}
										reviewLocation="ratesmobile_region"
										queryType="reviews"
									/>
								}
								control={
									<ReviewsSendHOC>
										<AddReviewContainerV2
											reviewLocation="ratesmobile_region"
											queryType="operators"
											selectProvidersPlaceholder={text.filtersOperator}
											textHeader={text.WRITE_REVIEW}
										/>
									</ReviewsSendHOC>
								}
							/>
						</Container>
					)}
				</>
			) : (
				<Container>
					<EmptyStubWrapper
						headerText={text.NO_OPERATORS_HEADER}
						displayText={text.no_operator_info}
						buttonText={text.TO_MAIN_PAGE}
						iconHeader={"icon-balance"}
						iconButton={"icon-playlist-add"}
					/>
				</Container>
			)}
		</>
	);
};

export default pipe(observer, inject("ApplicationModel"), withRouter)(List);
